// import CommonJS module and export inicialized as ES module
import initSentry from '../../initSentry';

const { Sentry, captureException } = initSentry();

export { Sentry, captureException };
